const AppointmentStatus = {
    SCHEDULED: "SCHEDULED", // agendado
	CONFIRMED: "CONFIRMED", // confirmado
	IN_PROGRESS: "IN_PROGRESS", // em andamento
	COMPLETED: "COMPLETED", // concluído
	CANCELED: "CANCELED", // cancelado
	NO_SHOW: "NO_SHOW" // não compareceu
}

export default AppointmentStatus;